import PerformanceComponent from './PerformanceComponent';

export default PerformanceComponent;
